import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface RegionHierarchy {
  regionDepth1?: string;
  regionDepth2?: string;
  regionDepth3?: string;
}

type joinStateType = {
  isJoinProcessStartedProperly: boolean;

  advertisementTermsAgreement?: boolean;
  marketingTermsAgreement?: boolean;
  job?: '농업 종사자' | '농기계 사업 종사자' | '일반 회원';
  joinReasons?: string;
  joinReasonEtc?: string;
  tractorOwnCheck?: string;

  // 농업 종사자 (추가 정보)
  cropTypes?: string;
  cropName?: string;

  // 농기계 사업 종사자 (추가 정보)
  businessName?: string;
  businessType?: string;
  businessTypeEtc?: string;

  // 일반 회원 (추가 정보)
  detailJob?: string;
  residence: RegionHierarchy;
};

const initialState: joinStateType = {
  isJoinProcessStartedProperly: false,

  advertisementTermsAgreement: undefined,
  marketingTermsAgreement: undefined,
  job: undefined,
  joinReasons: undefined,
  joinReasonEtc: undefined,
  tractorOwnCheck: undefined,

  // 농업 종사자 (추가 정보)
  cropTypes: undefined,
  cropName: undefined,

  // 농기계 사업 종사자 (추가 정보)
  businessName: undefined,
  businessType: undefined,
  businessTypeEtc: undefined,

  // 일반 회원 (추가 정보)
  detailJob: undefined,
  residence: {
    regionDepth1: undefined,
    regionDepth2: undefined,
    regionDepth3: undefined,
  },
};

export const userJoinSlice = createSlice({
  name: 'userJoin',
  initialState,
  reducers: {
    changeIsJoinProcessStartedProperly: (state, action: PayloadAction<boolean>) => {
      state.isJoinProcessStartedProperly = action.payload;
    },

    changeAdvertisementTermsAgreement: (state, action: PayloadAction<boolean>) => {
      state.advertisementTermsAgreement = action.payload;
    },

    changeMarketingTermsAgreement: (state, action: PayloadAction<boolean>) => {
      state.marketingTermsAgreement = action.payload;
    },

    changeJob: (state, action: PayloadAction<'농업 종사자' | '농기계 사업 종사자' | '일반 회원'>) => {
      state.job = action.payload;
    },

    changeJoinReasons: (state, action: PayloadAction<string>) => {
      state.joinReasons = action.payload;
    },

    changeJoinReasonEtc: (state, action: PayloadAction<string>) => {
      state.joinReasonEtc = action.payload;
    },

    changeTractorOwnCheck: (state, action: PayloadAction<string>) => {
      state.tractorOwnCheck = action.payload;
    },

    // 농업 종사자
    changeCropType: (state, action: PayloadAction<string>) => {
      state.cropTypes = action.payload;
    },

    changeCropName: (state, action: PayloadAction<string>) => {
      state.cropName = action.payload;
    },

    // 농기계 사업 종사자
    changeBusinessType: (state, action: PayloadAction<string>) => {
      state.businessType = action.payload;
    },

    changeBusinessTypeEtc: (state, action: PayloadAction<string>) => {
      state.businessTypeEtc = action.payload;
    },

    changeBusinessName: (state, action: PayloadAction<string>) => {
      state.businessName = action.payload;
    },

    // 일반 회원
    changeJobEtc: (state, action: PayloadAction<string>) => {
      state.detailJob = action.payload;
    },

    changeResidence: (state, action: PayloadAction<RegionHierarchy>) => {
      state.residence = action.payload;
    },
  },
});
